import { render } from "./DashMain.vue?vue&type=template&id=875f7bca&scoped=true"
import script from "./DashMain.vue?vue&type=script&lang=js"
export * from "./DashMain.vue?vue&type=script&lang=js"

import "./DashMain.vue?vue&type=style&index=0&id=875f7bca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-875f7bca"]])

export default __exports__